<template>
  <div class="body">
    <van-nav-bar title="我的优惠券" left-text left-arrow @click-left="onClickLeft" class="topNav"/>
    <div class="content">
      <van-tabs v-model="active" animated color="#e9aea8">
        <van-tab title="未使用">
          <CouponItem active="0"/>
        </van-tab>
        <van-tab title="已使用">
          <CouponItem active="1"/>
        </van-tab>
        <van-tab title="已过期">
          <CouponItem active="2"/>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
import CouponItem from "./CouponItem.vue";
import { Tab, Tabs } from "vant";
import Vue from "vue";
Vue.use(Tab).use(Tabs);
export default {
  components: {
    CouponItem
  },
  data() {
    return {
      active: 0
    };
  },
  created() {},
  activated() {},
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    }
  }
};
</script>
<style lang="less" scoped>
@import url("../../style/skin.less");
.body {
  background: #f4f8fb;
  min-height: 100vh;
  overflow: hidden;
  .topNav {
    position: fixed;
    width: 100%;
    top: 0px;
    i {
      color: #323233 !important;
    }
  }
  .content {
    margin-top: 46px;
  }
}
</style>